import React from 'react';

import PropTypes from 'prop-types';
import {
    connect,
} from 'react-redux';

import {
    LiveCheckModal,
} from 'wanderu-components-search';
import {
    tripSummarySelectors,
} from 'wanderu-ducks-search';
import {
    tripSelectors,
} from 'wanderu-ducks-trips';
import {
    selectCurrency,
    selectLocale,
} from 'wanderu-i18n';

import {
    buildBookingButtonUrl,
} from './utils';
import BookButtonComponent from '../../components/TripSummary/BookButton/BookButton';
import {
    ERROR,
} from '../../constants';

function BookButton(props) {
    if (!props.href) {
        const goBack = () => window.location.assign('/');

        return (
            <LiveCheckModal
                funnelStage="trip_summary"
                itineraryId={props.itineraryId}
                liveCheckData={props.liveCheckData}
                modalState={ERROR}
                onGoBack={goBack}
                trips={props.trips}
            />
        );
    }

    return (
        <BookButtonComponent {...props} />
    );
}

BookButton.propTypes = {
    href: PropTypes.string,
    itineraryId: PropTypes.string,
    liveCheckData: PropTypes.object,
    trips: PropTypes.arrayOf(PropTypes.object).isRequired,
};

function mapStateToProps(state, ownProps) {
    const {
        searchQueries,
        seats,
        tripIds,
        tripItineraryId,
        wheelchairs,
    } = ownProps;

    const lcOpts = { seats, wheelchairs };
    const busy = tripSummarySelectors.selectLiveChecksInProgress(state, tripIds, lcOpts);
    const liveCheckData = tripSummarySelectors.selectLiveCheckData(state, tripIds, lcOpts);
    const checkoutData = tripSummarySelectors.selectCheckoutData(state, tripIds, lcOpts);
    const currency = selectCurrency(state);
    const locale = selectLocale(state);
    const deeplink = checkoutData && tripIds.every(
        (tripId) => checkoutData[tripId] && !checkoutData[tripId].nativeBookingEnabled,
    );

    let href = buildBookingButtonUrl({
        checkoutData,
        currency,
        locale,
        searchQueries,
        tripIds,
        tripItineraryId,
    });

    let deepLinkData;

    if (deeplink) {
        deepLinkData = checkoutData[tripIds[0]].link;
        href = deepLinkData.href;
    }

    const trips = [];

    const getTrip = (tripId) => {
        const trip = tripSelectors.selectTripSet(state, tripId);

        trips.push(trip);
    };

    tripIds.forEach((tripId) => {
        getTrip(tripId);
    });

    return {
        busy,
        currency,
        deeplink,
        deepLinkData,
        href,
        itineraryId: tripItineraryId,
        liveCheckData,
        locale,
        trips,
    };
}

export {
    buildBookingButtonUrl,
    mapStateToProps,
};
export default connect(mapStateToProps)(BookButton);
